export default __webpack_public_path__ + "static/media/laughingMan.6ffa4a20.jpg";